export const QueryKeys = {
  SESSION_TOKEN: "SESSION_TOKEN",
};